/**
 * Checks arrays have same items - order doesn't matter
 * !!! With assumption - all array's items are unique !!!
 * @param array1 array of strings
 * @param array2 array of strings
 */
export function areArraysEqual(array1, array2) {
    return array1.length === array2.length
        && array1.every(x => array2.includes(x));
}
//# sourceMappingURL=areArraysEqual.js.map